var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.92841 14C2.41569 14 2 13.5972 2 13.0972C2 12.8333 2.097 12.625 2.27712 12.4444L6.71131 7.99999L2.27712 3.55554C2.11085 3.38889 2 3.16665 2 2.91665C2 2.40277 2.41569 2.01388 2.92841 2.01388C3.17783 2.01388 3.38568 2.1111 3.5658 2.29167L7.98614 6.7222L12.4342 2.29167C12.6282 2.08331 12.836 2 13.0855 2C13.5982 2 14 2.40277 14 2.90277C14 3.15277 13.9169 3.3611 13.7229 3.55554L9.28869 7.99999L13.709 12.4305C13.8892 12.6111 13.9862 12.8333 13.9862 13.0972C13.9862 13.5972 13.5843 14 13.0716 14C12.8083 14 12.5866 13.8889 12.4065 13.7222L7.98614 9.29165L3.59353 13.7222C3.41338 13.9028 3.17783 14 2.92841 14Z",
    fill: "#484848"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.112a33187f58322b90859059aa6ed314.svg";
export { ForwardRef as ReactComponent };